import { Trans } from 'react-i18next'

import { ConditionFeatureFlag, ConditionTextOperator } from '@makyoapp/makyo-common'
import { ArrowShortRight16 } from '@makyoapp/makyo-icon/icon'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'
import { Tooltip } from '@makyoapp/makyo-ui'

import { appIconKeys } from '@/shared/icons/constants'

import VariableGlobalVariables from '../VariableSelectV2/VariableGlobalVariables'
import { useConditionRepeaterContext } from './ConditionRepeaterContext'
import { useConditionSelectContext } from './ConditionSelectContext'

export function ConditionGlobalVariablesDD() {
  const { id, setOpen, isRhs, index } = useConditionSelectContext()
  const { onChange, value } = useConditionRepeaterContext()
  const key = isRhs ? 'rhs' : 'lhs'

  return (
    <VariableGlobalVariables
      id={id}
      onChange={(e) => {
        const nextCond = [...value.conditions]
        if (!isRhs) {
          nextCond[index].operator = ConditionTextOperator.IsEqual
        }
        nextCond[index] = {
          ...nextCond[index],
          [key]: {
            ...e,
            flag: ConditionFeatureFlag.GlobalVariable,
          },
        }
        onChange?.({ isAny: value.isAny, conditions: nextCond })
        setOpen(false)
      }}
      onHide={() => setOpen(false)}
    />
  )
}

export function ConditionGlobalVariablesStatement({ statement }: { statement: any }) {
  return (
    <Tooltip
      content={
        <div className='flex-c'>
          <div className='flex-c whitespace-nowrap'>
            <MaterialIcon size={16} icon={appIconKeys.globalVariable} />
            <Trans>Global Variable</Trans>
          </div>

          <div className='flex-c'>
            <ArrowShortRight16 />

            <div className='flex-c whitespace-nowrap'>
              <MaterialIcon size={16} icon={appIconKeys.storage} />
              {statement.value}
            </div>
          </div>
        </div>
      }
    >
      <div className='flex items-center gap-1 min-w-0'>
        <MaterialIcon icon={appIconKeys.globalVariable} size={14} />
        {statement.value}
      </div>
    </Tooltip>
  )
}
